import { GridColDef } from "@mui/x-data-grid";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { Switch, Tooltip } from "@mui/material";
import ActionButton from "../client-config/action-button";
import {
  FILTER_DEFAULT_VISIBILITY_LABELS,
  FILTER_SELECTION_MODE_LABELS,
  FILTER_SOURCE_LABELS,
} from "./enum-labels";
import { FilterShape, FilterTypeDetail } from "./types";

export const getColumns = ({
  onEdit,
  onDelete,
  onToggleEnabled,
}: {
  onEdit: (row: FilterTypeDetail) => void;
  onDelete: (row: FilterTypeDetail) => void;
  onToggleEnabled: (row: FilterTypeDetail) => void;
}): GridColDef[] => [
  { field: "code", headerName: "Code", flex: 1 },
  { field: "label", headerName: "Label", flex: 1 },
  {
    field: "shapeId",
    headerName: "Shape",
    flex: 1,
    valueGetter: (value: FilterShape) => FilterShape[value] ?? value,
  },
  {
    field: "source",
    headerName: "Source",
    flex: 1,
    valueGetter: (value: keyof typeof FILTER_SOURCE_LABELS) =>
      FILTER_SOURCE_LABELS[value] ?? value,
  },
  {
    field: "selectionMode",
    headerName: "Selection Mode",
    flex: 1,
    valueGetter: (value: keyof typeof FILTER_SELECTION_MODE_LABELS) =>
      FILTER_SELECTION_MODE_LABELS[value] ?? value,
  },
  {
    field: "defaultVisibility",
    headerName: "Default Visibility",
    flex: 1,
    valueGetter: (value: keyof typeof FILTER_DEFAULT_VISIBILITY_LABELS) =>
      FILTER_DEFAULT_VISIBILITY_LABELS[value] ?? value,
  },
  { field: "sortOrder", headerName: "Sort Order", maxWidth: 110 },
  { field: "optionCount", headerName: "Options", maxWidth: 100 },
  {
    field: "isEnabled",
    headerName: "Enabled",
    maxWidth: 100,
    align: "center",
    headerAlign: "center",
    renderCell: (params) => (
      <Tooltip
        title={params.row.isEnabled ? "Click to disable" : "Click to enable"}
        placement="top"
      >
        <Switch
          checked={params.row.isEnabled}
          onChange={(e) => {
            e.stopPropagation();
            onToggleEnabled(params.row);
          }}
          onClick={(e) => e.stopPropagation()}
          color="success"
          size="small"
        />
      </Tooltip>
    ),
  },
  {
    field: "actions",
    type: "actions",
    flex: 1,
    align: "right",
    maxWidth: 200,
    getActions: ({ row }: { row: FilterTypeDetail }) => [
      <ActionButton
        key="edit"
        onClick={(e) => {
          e.stopPropagation();
          onEdit(row);
        }}
      >
        <EditIcon fontSize="small" />
      </ActionButton>,
      <ActionButton
        key="delete"
        onClick={(e) => {
          e.stopPropagation();
          onDelete(row);
        }}
      >
        <DeleteIcon fontSize="small" />
      </ActionButton>,
    ],
  },
];

export const pageTitle = "Filter Types";
